/*
 * @author Andrey Patyuchenko
 * @email  apatyuchenko@atlassian.com
 * @email  andrey.patyuchenko@gmail.com
 * @date   09/08/2022
 */

import React from "react";
import { FormControl, FormControlLabel, Radio, RadioGroup, } from "@mui/material";
import SlackUserChannelSelectorControl from "../../controls/SlackUserChannelSelectorControl";
import { SummaryNotificationConfig } from "../../interfaces/Global";
import { UseFormReturnType } from "@mantine/form";

export interface ConfigDeliveryProps {
	form: UseFormReturnType<SummaryNotificationConfig>;
}

export default function ConfigDelivery({ form }: ConfigDeliveryProps) {

	const [ deliverTo, setDeliverTo ] = React.useState(form.values.channel || window.location.href.includes("?code=") ? "channel" : "self");

	return (
		<FormControl sx={{ mb: 2 }}>
			<RadioGroup
				value={deliverTo}
				onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
					const value = (event.target as HTMLInputElement).value;
					setDeliverTo(value);
					form.setFieldValue("channel", null);
				}}
			>
				<FormControlLabel value="self" control={<Radio/>} label="Send to me"/>
				<FormControlLabel value="channel" control={<Radio/>} label="Send to channel"/>
			</RadioGroup>
			{deliverTo === "channel" &&
				<SlackUserChannelSelectorControl
					channel={form.values.channel ?? undefined}
					error={String(form.errors.channel)}
					redirectUri={process.env.NODE_ENV === "development" ? "https://jwt.io" :
						window.location.origin + window.location.pathname}
					onChange={(channel) => form.setFieldValue("channel", channel)}
				/>}
		</FormControl>
	);

}